import React, { useState } from 'react';
import { useParams } from 'react-router-dom'; // Import Link for navigation

const CreateStructure = ({ onSubmit, propertyId }) => {
    const { id } = useParams(); // Get the residential property ID from the URL
    const [structureType, setStructureType] = useState('');
    const [squareFootage, setSquareFootage] = useState(0);
    const [constructionStartDate, setConstructionStartDate] = useState('');
    const [constructionEndDate, setConstructionEndDate] = useState('');
    const [error, setError] = useState('');

    const typeOptions = [
        { value: '', label: 'Select type…' },
        { value: 'House', label: 'House' },
        { value: 'Cabin', label: 'Cabin' },
        { value: 'Garage', label: 'Garage' },
        { value: 'MachineShed', label: 'MachineShed' },
        { value: 'Pool', label: 'Pool' },
        { value: 'PoolHouse', label: 'PoolHouse' },
    ];

    // Form submission handler
    const handleSubmit = async (event) => {
        event.preventDefault();

        const newStructureData = {
            asset_type_1: 'physical_asset',
            asset_type_2: 'structure',
            type: structureType,
            square_footage: squareFootage,
            construction_start_date: constructionStartDate || null,
            construction_end_date: constructionEndDate || null,
            residential_property: propertyId,  // Link to Residential Property
        };

        onSubmit(newStructureData);
    };

    return (
        <div>
            <h2 style={{ marginTop: 0 }}>Create New Structure</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label">Structure Type</label>
                    <select
                        className="form-select"
                        value={structureType}
                        onChange={(e) => setStructureType(e.target.value)}
                        required
                    >
                        {typeOptions.map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                    </select>
                </div>
                <div className="mb-3">
                    <label className="form-label">Square Footage</label>
                    <input
                        className="form-control"
                        type="number"
                        min="0"
                        value={squareFootage}
                        onChange={(e) => setSquareFootage(parseFloat(e.target.value) || 0)}
                        required
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label">Construction Start Date</label>
                    <input
                        className="form-control"
                        type="date"
                        value={constructionStartDate}
                        onChange={(e) => setConstructionStartDate(e.target.value)}
                        required
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label">Construction End Date</label>
                    <input
                        className="form-control"
                        type="date"
                        value={constructionEndDate}
                        onChange={(e) => setConstructionEndDate(e.target.value)}
                        required
                    />
                </div>
                <div className="d-flex justify-content-end gap-2">
                    <button type="submit" className="btn btn-success">Add Structure</button>
                </div>
            </form>
            {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
        </div>
    );
};

export default CreateStructure;